export const ADD_UPDATE_VEHICLE_INFO = 'ADD_UPDATE_VEHICLE_INFO';
export const CLEAR_VEHICLES_STORE = 'CLEAR_VEHICLES_STORE';
export const UPDATE_VEHICLE_LIST = 'UPDATE_VEHICLE_LIST';
export const ADD_ALL_TAGS = 'ADD_ALL_TAGS';
export const PAGINATE_VEHICLES = 'PAGINATE_VEHICLES';
